var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDetailsAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_account_details",
    transform: "translate(20185.902 1230.521)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_652",
    "data-name": "Ellipse 652",
    cx: 3.395,
    cy: 3.545,
    rx: 3.395,
    ry: 3.545,
    transform: "translate(-20182.594 -1230.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48669",
    "data-name": "Path 48669",
    d: "M240.356,69.667a5.412,5.412,0,0,1,1.169-3.365.982.982,0,0,0-.521.2,3.287,3.287,0,0,1-4.223-.02.933.933,0,0,0-.81-.189,6.176,6.176,0,0,0-3.736,5.34c-.092.833.346,2.864,6.623,2.894a16.707,16.707,0,0,0,3.892-.361A5.441,5.441,0,0,1,240.356,69.667Z",
    transform: "translate(-20418.127 -1289.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48377",
    "data-name": "Path 48377",
    d: "M245.794,65.413a4.25,4.25,0,1,0,4.255,4.25,4.249,4.249,0,0,0-4.255-4.25Zm.436,6.664a1.031,1.031,0,0,1-.723.327.622.622,0,0,1-.393-.134.489.489,0,0,1-.171-.406,1.631,1.631,0,0,1,.047-.3c.018-.08.046-.188.083-.319l.479-1.785a.353.353,0,0,1,.013-.063.278.278,0,0,0,.006-.058.2.2,0,0,0-.1-.2,1.359,1.359,0,0,0-.375-.053v-.213q.227-.015.657-.064t.609-.083l.343-.066-.62,2.272c-.052.195-.088.329-.106.406a2.094,2.094,0,0,0-.071.376c0,.057.013.094.04.111a.152.152,0,0,0,.085.026c.08,0,.18-.068.3-.2a2.971,2.971,0,0,0,.316-.432l.176.113a5.38,5.38,0,0,1-.6.765Zm.633-4.293a.538.538,0,1,1,.156-.38.517.517,0,0,1-.153.38Z",
    transform: "translate(-20417.951 -1289.052)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDetailsAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_details_account.02d6864b56ad6ae7ae8fa2bd941c31a3.svg";